/** See docs/MULTI_APP_WORKSPACE.md §5.2 */

export type NoteWindowState = 'open' | 'minimized';
export type NoteWindowMode = 'floating' | 'maximized';

export interface NoteWindow {
  /** Identity is the note: opening the same note twice focuses one window. */
  noteId: number;
  /** Cached so the dock has a label before the note is fetched. */
  title: string | null;
  snippet: string | null;
  color: string | null;
  /** Locked notes never cache a content snippet (§7). */
  locked: boolean;
  state: NoteWindowState;
  mode: NoteWindowMode;
  z: number;
  openedAt: number;
  lastFocusedAt: number;
}

export type NoteWindowMeta = Partial<Pick<NoteWindow, 'title' | 'snippet' | 'color' | 'locked'>>;

export const NOTE_WINDOWS_VERSION = 1;

/** Dock cap — beyond this the least-recently-focused minimized window is evicted. */
export const MAX_WINDOWS = 12;

/**
 * How many window bodies stay mounted (hidden when minimized) so caret,
 * scroll and undo history survive a minimize. Beyond this, a window keeps only
 * its dock metadata and its content is refetched on restore — never a data
 * loss, autosave has already persisted the text. §5.4
 */
export const MAX_ALIVE_BODIES = 3;

/** Persisted title/snippet length — keeps the payload tiny. */
export const MAX_CACHED_TEXT = 120;
